import React from "react";
import { useStores } from "@ms/uno-controls/lib/local/hooks/useStores";
import { LazyLoopResponseSection } from "./LazyLoopResponseSection";
import { Store } from "@ms/uno-stores/lib/local/stores/Store";
import { useConfigProvider } from "@ms/uno-controls/lib/local/hooks/useConfigProvider";
/**
 * The LoopResponseSectionContainer component
 * @param props - The props for the component
 */ export const LoopResponseSectionContainer = ({ fetchAccessTokenCallback, taskId })=>{
    const configProvider = useConfigProvider();
    const [basicTaskStore] = useStores([
        Store.BasicTask
    ]);
    const loopPageUrl = basicTaskStore?.getTask(taskId).data?.internalProperties.copilot?.loopPageUrl;
    if (!(loopPageUrl && configProvider().flights.EnableGsdInBasicPlans)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(LazyLoopResponseSection, {
        fetchAccessTokenCallback: fetchAccessTokenCallback,
        loopPageUrl: loopPageUrl,
        taskId: taskId
    });
};
